import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 22v-3h12v-6h-2v4H7v-3l-4 4zM21 6l-4-4v3H5v6h2V7h10v3z"
}), 'RepeatTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RepeatTwoTone.js
// module id = 5752
// module chunks = 2